import * as React from "react";
import Input from "../../Input-new/Input";
import Dropdown from "../../Dropdown/Dropdown";
import SelectLender from "../../SelectLender/SelectLender";
import SelectAgentAll from "../../SelectAgentAll/SelectAgentAll";

const Loan = ({isAgent, data, handleChangeInput, handleChangeDropdown, addNewItem, newLender, newAgent, viewMode, deleted}) => {
    return (
        <div className="Loan">
            <div className="Loan_column">
                <SelectLender
                    className="Loan_column_item"
                    isFromProperty
                    value={data.LENDER_ID}
                    valueKey="LENDER_ID"
                    label="Lender"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    withAddNew
                    addNewItem={addNewItem}
                    viewMode={viewMode}
                    deleted={deleted}
                    newLender={newLender}
                    withContact
                />
                <Dropdown
                    className="Loan_column_item"
                    data={data}
                    isFromProperty
                    optionsType="loan"
                    value={data.LOAN_TYPE}
                    valueKey="LOAN_TYPE"
                    label="Loan Type"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="integer"
                    name="LOAN_AMOUNT"
                    label="Loan Amount"
                    value={data.LOAN_AMOUNT}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="LTV"
                    label="LTV"
                    value={data.LTV}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="INTEREST_RATE"
                    label="Interest Rate"
                    value={data.INTEREST_RATE}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="number"
                    name="AMORTIZATION"
                    label="Amortization"
                    value={data.AMORTIZATION}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
            </div>
            <div className="Loan_column">
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="number"
                    name="TERM"
                    label="Term"
                    value={data.TERM}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="date"
                    name="MATURITY_DATE"
                    label="Maturity Date"
                    value={data.MATURITY_DATE}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="integer"
                    name="ANNUAL_LOAN_PAYMENT"
                    label="Annual Loan Payment"
                    value={data.ANNUAL_LOAN_PAYMENT}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="integer"
                    name="CASH_FLOW"
                    label="Cash Flow"
                    value={data.CASH_FLOW}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="CASH_ON_CASH"
                    label="Cash on Cash"
                    value={data.CASH_ON_CASH}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="DSCR"
                    label="DSCR"
                    value={data.DSCR}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
            </div>
            <div className="Loan_column">
                <Input
                    className="Loan_column_item"
                    placeholder="MM/DD/YYYY"
                    type="text"
                    valueType="date"
                    name="HSC_LISTED_DATE"
                    label="Date Listed"
                    value={data.HSC_LISTED_DATE}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="number"
                    name="HSC_EXPIRATION_NO_OF_MONTHS"
                    label="# Of Months"
                    value={data.HSC_EXPIRATION_NO_OF_MONTHS}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Loan_column_item"
                    placeholder="MM/DD/YYYY"
                    type="text"
                    valueType="date"
                    name="HSC_EXPIRATION_DATE"
                    label="Listing Expiration Date"
                    value={data.HSC_EXPIRATION_DATE}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="HSC_FEE_PERCENTAGE"
                    label="HSC Fee Percentage"
                    value={data.HSC_FEE_PERCENTAGE}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
            </div>
            <div className="Loan_column">
                <Input
                    className="Loan_column_item"
                    disabled
                    type="text"
                    valueType="float"
                    name="HSC_TOTAL_FEE"
                    label="Total Fee - Auto"
                    value={data.HSC_TOTAL_FEE}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <div className='referral-container'>
                    <Input
                        className="Loan_column_item"
                        type="text"
                        valueType="integer"
                        name="REFERRAL"
                        label="Referral"
                        value={data.REFERRAL}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        isDollar
                    />
                    <Input
                        className="referral-percent"
                        type="text"
                        valueType="percent"
                        name="REFERRAL_PERCENT"
                        value={data.REFERRAL_PERCENT}
                        disabled={isAgent}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                </div>
                <SelectAgentAll
                    isFromProperty
                    value={data.REFERRED_BY_ID}
                    valueKey="REFERRED_BY_ID"
                    typeKey="REFERRED_BY_TYPE"
                    label="Referred By"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    withAddNew
                    addNewItem={addNewItem}
                    newAgent={newAgent}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="integer"
                    name="CREDITS_AT_CLOSING"
                    label="Credits @ Closing"
                    value={data.CREDITS_AT_CLOSING}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="float"
                    name="HSC_LIST_FEE"
                    label="HSC Fee - auto"
                    value={data.HSC_LIST_FEE}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
            </div>
        </div>
    );
};

export default Loan;
